import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/web/components/ui/sheet";
import { Button } from "@/web/components/ui/button";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/free-quote", label: "Free Quote" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 w-full border-b border-white/10 bg-ink">
      <div className="mx-auto flex h-28 w-full max-w-screen-2xl items-center justify-between gap-4 px-4 md:h-52 md:px-6 lg:px-8">
        <Link to="/" aria-label="Cool Wave Air Conditioning home" className="flex flex-col items-start gap-1.5">
          <img
            src="/images/coolwave-logo.png"
            alt="Cool Wave Air Conditioning"
            className="h-auto w-[200px] max-h-16 md:w-[490px] md:max-h-48"
          />
          <div className="flex items-center gap-x-1.5 whitespace-nowrap pl-1 text-[8px] font-semibold uppercase tracking-[0.1em] text-white/85 sm:gap-x-2 sm:text-[9px] md:gap-x-2.5 md:text-[10px]">
            <span><span className="mr-1 text-brand-pink">▸▸▸</span>Air Conditioning</span>
            <span><span className="mr-1 text-brand-pink">▸▸▸</span>Refrigeration</span>
            <span><span className="mr-1 text-brand-pink">▸▸▸</span>Heat Pumps</span>
          </div>
        </Link>

        <div className="hidden items-center gap-6 md:flex lg:gap-8">
          <nav className="flex items-center gap-5 lg:gap-7">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  cn(
                    "whitespace-nowrap px-1 text-2xl font-semibold uppercase tracking-wide transition-colors",
                    isActive ? "text-brand" : "text-white hover:text-brand"
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <a
            href="tel:0272980080"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap text-2xl font-semibold text-white transition-colors hover:text-brand lg:inline-flex"
          >
            <Phone className="h-7 w-7" /> 027 298 0080
          </a>
        </div>

        <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" aria-label="Open menu" className="-translate-x-[70px] text-white hover:bg-white/10 hover:text-white md:translate-x-0">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[80%] sm:w-[360px]">
            <SheetTitle className="mb-6 text-base font-semibold">Menu</SheetTitle>
            <nav className="flex flex-col gap-4">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    cn(
                      "rounded-md px-2 py-2 text-base font-medium",
                      isActive ? "bg-brand-50 text-brand" : "text-ink hover:bg-surface"
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <a
                href="tel:0272980080"
                onClick={() => setMenuOpen(false)}
                className="mt-4 inline-flex cursor-pointer items-center justify-center gap-2 rounded-md bg-brand px-4 py-3 text-base font-semibold text-white"
              >
                <Phone className="h-4 w-4" /> 027 298 0080
              </a>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
